import { ShippingRateTerritorialScope } from './shipping-rate-territorial-scope';

export class DestinationShippingRate {
    public scope?: ShippingRateTerritorialScope;
    public countryId: number = 0;
    public stateIds: number[] = [];
    public postalCodes: string[] = [];

    public get onlyMainland(): boolean {
        if (this.scope === ShippingRateTerritorialScope.Provincial) {
            const mainlandStateIds = this.stateIds.filter((stateId) => ![7, 35, 38, 51, 52].some((id) => id === stateId));
            return mainlandStateIds.length === [7, 35, 38, 51, 52].length;
        }
        return false;
    }

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(
            this,
            json,
            {
                stateIds: json.stateIds ? json.stateIds.map((stateId: number) => stateId) : [],
                postalCodes: json.postalCodes ? json.postalCodes.map((postalCode: string) => postalCode) : [],
            });
    }

    public clone(): DestinationShippingRate {
        const destination: DestinationShippingRate = new DestinationShippingRate();

        destination.scope = this.scope;
        destination.countryId = this.countryId;
        destination.stateIds = this.stateIds;
        destination.postalCodes = this.postalCodes;

        return destination;
    }
}
